import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';

@Component({
    selector: 'app-complete-ticket-modal',
    templateUrl: './complete-ticket-modal.component.html',
    styleUrls: ['./complete-ticket-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, InlineSVGComponent],
})
export class CompleteTicketModalComponent {
    confirmCallback: () => void;
    ticketId: number;

    constructor(private modalRef: BsModalRef) {}

    decline(): void {
        this.modalRef.hide();
    }

    save(): void {
        this.confirmCallback();
        this.modalRef.hide();
    }
}
